export default __webpack_public_path__ + "static/media/IMG_4470.d1b795c7.jpg";